import type { KyInstance } from 'ky';

import { ensureError, formatString, isNotDefined } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Deletes a template batch detail by its template ID and batch template ID.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param templateId - The ID of the template to delete from.
 * @param batchTemplateId - The ID of the batch template detail to delete.
 * @returns A promise resolving to the operation result of the deletion.
 * @throws Error if either `templateId` or `batchTemplateId` is not provided, or if the request fails.
 */
export const deleteTemplateBatchDetail = async (
  instance: KyInstance,
  templateId?: number,
  batchTemplateId?: number
) => {
  try {
    if (isNotDefined(templateId) || isNotDefined(batchTemplateId)) {
      throw new Error('Template ID and Batch template ID must be provided for deletion.');
    }

    return await instance
      .delete<OperationResult>(
        formatString(Uri.template.deleteTemplateBatchDetailById, templateId.toString(), batchTemplateId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
